{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "查看所有選項",
  "Spoiler_Reveal_Tooltip": "點擊顯示",
  "VerticalEmbed_Event_Error_Subtitle": "This event has been deleted, replace it with another event.",
  "Viewer_Toolbar_Twitter_Tooltip": "發表此推文",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "項目已收起",
  "Spoiler_Reveal_Video_CTA": "揭示影片",
  "VerticalEmbed_Pricing_Plan": "Plan only",
  "Image_Expand_Button_AriaLabel": "展開圖片",
  "VerticalEmbed_From_Price": "From",
  "Poll_Viewer_ShowAllResults_CTA": "查看所有結果",
  "Spoiler_Reveal_Image_Placeholder": "此圖片有雷",
  "VerticalEmbed_Ribbon": "Sale",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "滑桿",
  "VerticalEmbed_Error_Subtitle": "This item has been deleted, replace it with another item.",
  "Poll_Viewer_Multiselect_Footer": "您可以投票給超過一個答案。",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "顯示更多音訊控制",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Failed to load service",
  "Fullscreen_Close_Button_AriaLabel": "關閉",
  "VerticalEmbed_Event_Fetch_Error_Title": "Failed to load event",
  "UploadFile_Viewer_Loader": "正在載入 {{fileType}}",
  "Polls_Plugin_User_Avatar_Alt": "使用者頭像",
  "Preview_ReadMore_Label": "閱讀更多",
  "Spoiler_Insert_Tooltip": "Spoiler",
  "VerticalEmbed_Product_Fetch_Error_Title": "Failed to load product",
  "Fullscreen_Shrink_Button_AriaLabel": "Shrink",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "數量",
  "Spoiler_Reveal_Gallery_Placeholder": "此圖庫有雷",
  "Fullscreen_Expand_Button_AriaLabel": "Expand",
  "VerticalEmbed_Bookings_Button": "立即預訂",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "取消靜音",
  "Spoiler_Reveal_Gallery_CTA": "揭示圖庫",
  "Poll_Viewer_ShowLess_CTA": "顯示較少",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "靜音",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+ {{anonNumber}} 位無名氏",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "追蹤",
  "VerticalEmbed_Products_Button": "立即購買",
  "Poll_Viewer_Toast_Error_ServerDown": "無法連線伺服器。請稍後再試一次。",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "{{count}} 個人投票給這個答覆",
  "Poll_Viewer_VoteCount": "{{number}} 票",
  "VerticalEmbed_Events_Button": "立即報名",
  "Spoiler_Reveal_Image_CTA": "揭示圖片",
  "Poll_Viewer_Toast_Error_Connection": "沒有網路，請檢查您的連線。",
  "Poll_Viewer_Visibility_Owner_Footer": "只有您能查看結果。",
  "VerticalEmbed_Booking_Error_Title": "Service deleted",
  "VerticalEmbed_Product_Error_Title": "Product deleted",
  "VerticalEmbed_Fetch_Error_Subtitle": "Unable to load item information.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "{{count}} 個人投票給這個答覆",
  "VerticalEmbed_Event_Error_Title": "Event deleted",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "項目已展開",
  "Audio_Plugin_Cover_Alt": "音訊封面",
  "Spoiler_Reveal_Video_Placeholder": "此影片有雷",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Unable to load product information.",
  "VerticalEmbed_Fetch_Error_Title": "Failed to load item",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "This product has been deleted, replace it with another product.",
  "VerticalEmbed_Booking_Error_Subtitle": "This service has been deleted, replace it with another service.",
  "Preview_SeeFullPost_Label": "查看完整文章",
  "UploadFile_Viewer_Download": "下載 {{fileType}}",
  "VerticalEmbed_Units_Hour": "{{hours}} 小時",
  "VerticalEmbed_Units_Minute": "{{minutes}} 分鐘",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Unable to load event information.",
  "VerticalEmbed_Error_Button": "Replace",
  "VerticalEmbed_Error_Title": "Item deleted",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Unable to load service information.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
